import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Checkbox from "../../../../../../components/form/Checkbox";
import { WhiteButton } from "../../../../../../components/ui/Buttons";
function ZonesSidebarFilter() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isGeofence, setIsGeofence] = useState<boolean>(() =>
    new URLSearchParams(window.location.search).getAll("siteTypes").includes("geofence")
  );
  const [isSafetyZone, setIsSafetyZone] = useState<boolean>(() =>
    new URLSearchParams(window.location.search).getAll("siteTypes").includes("safety-zone")
  );

  useEffect(() => {
    const siteTypes = searchParams.getAll("siteTypes");
    setIsGeofence(siteTypes.includes("geofence"));
    setIsSafetyZone(siteTypes.includes("safety-zone"));
  }, [searchParams]);

  return (
    <div className="font-semibold">
      <div className="font-normal">
        <div className="flex flex-col gap-2 my-2">
          <Checkbox
            value="geofence"
            label="Geofences"
            onClick={() => setIsGeofence((prev) => !prev)}
            name="siteTypes"
            checked={isGeofence}
          />
          <Checkbox
            value="safety-zone"
            label="Safety Zone"
            onClick={() => setIsSafetyZone((prev) => !prev)}
            name="siteTypes"
            checked={isSafetyZone}
          />
        </div>
        <div className="flex flex-col gap-2 my-2">
          <WhiteButton
            text="View / Edit"
            onClick={() => navigate("/sites/zones")}
          />
          <WhiteButton text="Add a Zone" onClick={() => navigate("add-zone")} />
        </div>
      </div>
      <hr className="my-8 opacity-80" />
    </div>
  );
}

export default ZonesSidebarFilter;
